import dayjs from 'dayjs';
import { t } from 'ttag';

import { useFreePushups } from '@hook/useFreePushups';
import { Alert } from '@ui/Alert';
import { ProductDetailsSellerActionsContainer } from '@containers/product/ProductDetailsSellerActions';
import { ProductDetailsFreePushAlert } from '@components/ProductDetailsFreePushAlert';
import { ProductDetailsProductStatsContainer } from '@containers/product/ProductDetailsProductStats';

import s from './ProductDetailsSellerSettings.sss';

type Product = {
  __typename?: 'ProductDetails',
  id: number,
  publishDate?: string | null,
  isOutOfStock: boolean,
}

interface Props {
  className?: string,
  product?: Product,
}

export const ProductDetailsSellerSettings: React.FC<Props> = ({
  className,
  product,
}) => {
  const {
    freePushupsLeft,
    nextFreePushupAt,
    freePushupAvailable,
    canUseFreePush,
  } = useFreePushups(product?.id);

  return (
    <div className={className}>
      {!!product?.publishDate && (
        <p className={s.date}>
          {t`Опубліковано`}
          &nbsp;
          {dayjs(product.publishDate).format('DD.MM.YYYY')}
        </p>
      )}

      <ProductDetailsSellerActionsContainer
        className={s.actions}
        product={product}
      />

      {!!freePushupsLeft && !!canUseFreePush && (
        <ProductDetailsFreePushAlert
          nextFreePushupAt={nextFreePushupAt}
          freePushupAvailable={freePushupAvailable}
        />
      )}

      <ProductDetailsProductStatsContainer
        className={s.stats}
        product={product}
      />

      {product?.isOutOfStock && (
        <Alert
          className={s.alert}
          theme='warning'
        >
          {t`У вас є замовлення на всі товари у наявності. Щоб товар став доступним, відредагуйте кількість товару`}
        </Alert>
      )}
    </div>
  );
};
